import { CircularProgress, Grid } from "@material-ui/core";
import { useState } from "react";
import { type FocusApi } from "../../../models/api";
import { useApiAllFocus } from "../../hooks";
import { Answer } from "../answer";
import { useStyles } from "./update-goal.styles";

type Props = {
  renderImage: (order: number) => void;
  answerClass: string;
  currentFocusId: number;
  reportSelection: (focusId: number) => void;
};

export const UpdateGoal = ({
  renderImage,
  answerClass,
  currentFocusId,
  reportSelection,
}: Props) => {
  const classes = useStyles();
  const [newFocusId, setNewFocusId] = useState<number>(currentFocusId);
  const { useQuery } = useApiAllFocus();
  const { data: focusData, isLoading } = useQuery();

  const onClick = (newFocus: FocusApi) => {
    setNewFocusId(newFocus.focusId);
    if (currentFocusId != newFocus.focusId) reportSelection(newFocus.focusId);
  };

  if (isLoading) {
    return (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <Grid container className={classes.container} spacing={2}>
      {focusData?.map((focus) => (
        <Answer
          answerClass={answerClass}
          renderImage={renderImage}
          key={focus.focusId}
          answer={{
            order: focus.focusId,
            focusId: focus.focusId,
            name: focus.name,
          }}
          isAnswerSelected={focus.focusId == newFocusId}
          onClick={() => onClick(focus)}
        />
      ))}
    </Grid>
  );
};
